import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import GrowthConsulting from "./pages/GrowthConsulting";
import SaaS from "./pages/SaaS";
import BuiltAtLabs from "./pages/BuiltAtLabs";
import Pulse from "./pages/Pulse";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Contact from "./pages/Contact";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/growth-consulting" element={<GrowthConsulting />} />
            <Route path="/saas" element={<SaaS />} />
            <Route path="/built-at-labs" element={<BuiltAtLabs />} />
            <Route path="/pulse" element={<Pulse />} />
            <Route path="/case-studies" element={<Pulse />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
        <Toaster position="bottom-right" theme="dark" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
